export default function CLogicalOperators() {
  return <h2>C Logical Operators</h2>;
}
